import { render, staticRenderFns } from "./home-shuguang.vue?vue&type=template&id=01058fd0&scoped=true&"
import script from "./home-shuguang.vue?vue&type=script&lang=ts&"
export * from "./home-shuguang.vue?vue&type=script&lang=ts&"
import style0 from "./home-shuguang.vue?vue&type=style&index=0&id=01058fd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01058fd0",
  null
  
)

export default component.exports